import React from 'react';
import './DeliveryMode.scss';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

export const DeliveryMode = (props) => {
    const {
        deliveryModes,
        deliveryPartners,
        deliveryMode,
        onDeliveryModeChange,
        onDeliveryPartnerChange,
        serviceability,
        payouts
    } = props;

    // Check if Porter is available for selection
    const isPorterAvailable = serviceability?.locationServiceAble && serviceability?.riderServiceAble;

    return (
        <div className="delivery-mode-container">
            {/* Delivery Mode Header */}
            <div className='font-14 bold-text pb-2'>Delivery Mode</div>

            {/* Delivery Mode Selection */}
            {deliveryModes?.length > 0 &&
                deliveryModes.map((item, index) => (
                    <FormControlLabel
                        key={index}
                        name={item.name}
                        value={item.value}
                        control={<Radio color="primary" size="small" />}
                        label={item.text}
                        checked={item.checked}
                        onChange={() => onDeliveryModeChange && onDeliveryModeChange(item)}
                    />
                ))
            }

            {/* Show Delivery Partner only if user selected Delivery */}
            {deliveryMode === "Delivery" && (
                <>
                    <div className='font-14 bold-text pt-3 pb-2'>Delivery Partner</div>

                    {deliveryPartners?.length > 0 &&
                        deliveryPartners.map((partner, index) => (
                            <div key={index} className={`partner-option ${partner.value === "porter" && !isPorterAvailable ? 'disabled' : ''}`}>
                                <FormControlLabel
                                    name={partner.name}
                                    value={partner.value}
                                    control={<Radio 
                                        color="primary" 
                                        size="small" 
                                        disabled={partner.value === "porter" && !isPorterAvailable}
                                    />}
                                    label={
                                        <div className="delivery-partner-label">
                                            {/* Add truck icon for Porter */}
                                            {partner.value === "porter" && (
                                                <LocalShippingIcon className="truck-icon" fontSize="small" />
                                            )}
                                            <span className="partner-name">{partner.text}</span>
                                            {/* Show Porter delivery charge ONLY when Porter is SELECTED/ACTIVE */}
                                            {partner.value === "porter"  && payouts && (
                                                <span className={`delivery-price ${serviceability?.locationServiceAble ? 'available' : 'unavailable'}`}>
                                                    {serviceability?.locationServiceAble ? `₹${payouts.total}` : "Not Available"}
                                                </span>
                                            )}
                                        </div>
                                    }
                                    checked={partner.checked}
                                    onChange={() => {
                                        // Only allow selection if Porter is available OR it's not Porter
                                        if (partner.value !== "porter" || isPorterAvailable) {
                                            onDeliveryPartnerChange && onDeliveryPartnerChange(partner);
                                        }
                                    }}
                                />
                            </div>
                        ))
                    }

                    {/* Show serviceability messages BELOW the radio buttons - Always show when serviceability data exists */}
                    {deliveryMode === "Delivery" && serviceability && (
                        <div className="serviceability-messages">
                            {!serviceability.locationServiceAble && (
                                <div className="error-message">
                                    <span className="icon">❌</span>
                                    <span className="text">Delivery not available to your location</span>
                                </div>
                            )}
                            {serviceability.locationServiceAble && !serviceability.riderServiceAble && (
                                <div className="warning-message">
                                    <span className="icon">⚠️</span>
                                    <span className="text">No riders available at the moment. Please try again later.</span>
                                </div>
                            )}
                            {serviceability.locationServiceAble && serviceability.riderServiceAble && (
                                <div className="success-message">
                                    <span className="icon">✅</span>
                                    <span className="text">Delivery available with Porter</span>
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};